<div class="container-fluid content-padded small-content">
  <div class="row justify-content-center">
    <div class="form-container">
      <form #forgotPassword="ngForm" class="col-lg-6 col-md-12 forgot-password-form" (ngSubmit)="requestNewPassword()" *ngIf="!token; else newPassword">
        <h1 class="form-title">Reset Password</h1>
        <div class="form-group">
          <label for="name">Username (email)</label>
          <input [disabled]="isSendingForm" type="text" [(ngModel)]="username" name="username" class="form-control" id="email" #userName="ngModel"
                 validateEmail="username" required>
          <small [hidden]="userName.valid || userName.pristine || isSendingForm" class="incorrect-field">
            Valid email is required
          </small>
        </div>
        <button type="submit" class="btn btn-outline-info submit" [disabled]="!forgotPassword.form.valid">
          Reset Password
        </button>
        <button class="btn btn-outline-info" (click)="goToLogin()">
          Back
        </button>
      </form>
      <ng-template #newPassword>
        <form #resetPassword="ngForm" class="col-lg-6 col-md-12 new-password-form" (ngSubmit)="sendNewPassword()">
          <h1 class="form-title">{{'It is time to change your password' | translate}}</h1>
          <p class="explanation">{{'Please enter your new password and click the Reset button.' | translate}}</p>
          <div class="form-group">
            <label for="name">{{'New Password' | translate}}</label>
            <input [disabled]="isSendingForm" type="password" [(ngModel)]="resetForm.password" name="resetForm.password" (ngModelChange)="resetForm.confirmPassword = ''"
              class="form-control" id="resetForm.password" #password="ngModel" validateEqual="resetForm.confirmPassword" required
              reverse="true" validatePassword="resetForm.password">
            <small [hidden]="password.valid || password.pristine || isSendingForm" class="incorrect-field">
              {{'Password is invalid' | translate}}
            </small>
          </div>
          <div [hidden]="!invalidPasswordRules" class="password-rules">
              <ul>
                <li [ngClass]="checkPasswordError(password.errors, rule.id)" *ngFor="let rule of passwordRules">{{rule.description}}</li>
              </ul>
            </div>
          <div class="form-group">
            <label for="name">{{'Confirm New Password' | translate}}</label>
            <input [disabled]="isSendingForm" type="password" [(ngModel)]="resetForm.confirmPassword" name="resetForm.confirmPassword"
              class="form-control" id="resetForm.confirmPassword" #confirmPassword="ngModel" validateEqual="resetForm.password"
              required>
            <small [hidden]="confirmPassword.valid || confirmPassword.pristine || isSendingForm" class="incorrect-field">
              {{'Password mismatch' | translate}}
            </small>
          </div>
          <button type="submit" class="btn btn-outline-info submit" [disabled]="!resetPassword.form.valid">
            {{'Reset' | translate}}
          </button>
          <button class="btn btn-outline-info" [disabled]="!resetPassword.form.valid" (click)="goBack()">
            {{'Back' | translate}}
          </button>
        </form>
      </ng-template>
    </div>
  </div>
</div>
